// extracted by mini-css-extract-plugin
export var effect = "subscribe-module--effect--a54e8";
export var effect__1 = "subscribe-module--effect__1--0601f";
export var effect__2 = "subscribe-module--effect__2--b157f";
export var effect__illustration = "subscribe-module--effect__illustration--2faef";
export var fullscreenNav = "subscribe-module--fullscreenNav--49f2d";
export var left = "subscribe-module--left--ba76c";
export var logo = "subscribe-module--logo--23c93";
export var phone = "subscribe-module--phone--e83c1";
export var right = "subscribe-module--right--92748";
export var spin = "subscribe-module--spin--ca0e9";
export var subscribe = "subscribe-module--subscribe--7c465";
export var subscribe__black = "subscribe-module--subscribe__black--ceb14";
export var subscribe__bloodorange = "subscribe-module--subscribe__bloodorange--58000";
export var subscribe__chartruse = "subscribe-module--subscribe__chartruse--8895f";
export var subscribe__cobalt = "subscribe-module--subscribe__cobalt--0f648";
export var subscribe__emerald = "subscribe-module--subscribe__emerald--4c49d";
export var subscribe__paper = "subscribe-module--subscribe__paper--f85de";
export var subscribe__pink = "subscribe-module--subscribe__pink--d2174";
export var subscribe__sky = "subscribe-module--subscribe__sky--57efc";
export var subscribe__white = "subscribe-module--subscribe__white--6dc30";
export var wrapper__black = "subscribe-module--wrapper__black--21629";
export var wrapper__bloodorange = "subscribe-module--wrapper__bloodorange--4e082";
export var wrapper__chartruse = "subscribe-module--wrapper__chartruse--7ea96";
export var wrapper__cobalt = "subscribe-module--wrapper__cobalt--9c408";
export var wrapper__emerald = "subscribe-module--wrapper__emerald--fbf30";
export var wrapper__paper = "subscribe-module--wrapper__paper--6fc5f";
export var wrapper__pink = "subscribe-module--wrapper__pink--16fa9";
export var wrapper__sky = "subscribe-module--wrapper__sky--6b279";
export var wrapper__white = "subscribe-module--wrapper__white--8feb0";